define('prototypes/fonts-autoload',['css','site_vars','LogExecutionTime'],function(css,site_vars,LogExecutionTime){
    var supportsWoff2 = (function(){
        if( !( "FontFace" in window ) ) {
            return false;
        }

        var s,f = new FontFace('t', 'url( "data:font/woff2;base64,d09GMgABAAAAAADwAAoAAAAAAiQAAACoAAEAAAAAAAAAAAAAAAAAAAAAAAAAAAAABmAALAogOAE2AiQDBgsGAAQgBSAHIBuDAciO1EZ3I/mL5/+5/rfPnTt9/9Qa8H4cUUZxaRbh36LiKJoVh61XGzw6ufkpoeZBW4KphwFYIJGHB4LAY4hby++gW+6N1EN94I49v86yCpUdYgqeZrOWN34CMQg2tAmthdli0eePIwAKNIIRS4AGZFzdX9lbBUAQlm//f262/61o8PlYO/D1/X4FrWFFgdCQD9DpGJSxmFyjOAGUU4P0qigcNb82GAAA" ) format( "woff2" )', {});
        f.load()['catch'](function() {});
        s = f.status;
        return s == 'loading' || s == 'loaded';
    })();

    var ua = window.navigator.userAgent,
        fontTypeSupported = 'woff',
        styleReady = false, callbacks = []; // defaut type

    // Use WOFF2 if supported
    if( supportsWoff2 ) {
        fontTypeSupported = 'woff2';
    } else if( ua.indexOf( "Android 4." ) > -1 && ua.indexOf( "like Gecko" ) > -1 && ua.indexOf( "Chrome" ) === -1 ) {
        // Android's Default Browser needs TTF instead of WOFF
        fontTypeSupported = 'ttf';
    } else {
        // Default to WOFF
        fontTypeSupported = 'woff';
    }
    var deps = ['css!'+site_vars.main_footer_css];
    if(fontTypeSupported!=='woff2') {
        deps.push('css!'+site_vars.domain_sharding_fonts+'/css/fonts-'+fontTypeSupported+'.css');
    }
    LogExecutionTime('Fonts autoload', 2);
    require(deps, function () {
        styleReady = true;
        LogExecutionTime('Fonts loaded', 3);
        callbacks.forEach(function(callback){
           callback.call();
        });
    });

    return function(callback){
        if(!styleReady){
            callbacks.push(callback);
        }
        return styleReady;
    }

});
